import React from 'react';

interface Props {
  width: number;
  height: number;
}

const SvgPassword = (props : Props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="#fff" d="M0 0h52v52H0z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.875 22.209v-6.5a4.875 4.875 0 1 0-9.75 0v6.5h9.75ZM26 5.959c-5.385 0-9.75 4.365-9.75 9.75v11.375h19.5V15.709c0-5.385-4.365-9.75-9.75-9.75Z"
      fill="#CAC4D0"
    />
    <path
      d="M30.875 23.209h1v-7.5a5.875 5.875 0 1 0-11.75 0v7.5h10.75Zm-13.625-7.5a8.75 8.75 0 1 1 17.5 0v10.375h-17.5V15.709Z"
      stroke="#fff"
      strokeOpacity={0.05}
      strokeWidth={2}
    />
    <path
      d="M39 21.125H13c-1.196 0-2.167.85-2.167 1.896v18.958c0 1.047.97 1.896 2.167 1.896h26c1.196 0 2.167-.85 2.167-1.896V23.021c0-1.047-.971-1.896-2.167-1.896Z"
      fill="#E3C993"
    />
    <path
      d="M13 22.125h26c.773 0 1.167.523 1.167.896v18.958c0 .373-.394.896-1.167.896H13c-.773 0-1.167-.523-1.167-.896V23.021c0-.373.394-.896 1.167-.896Z"
      stroke="url(#a)"
      strokeOpacity={0.1}
      strokeWidth={2}
    />
    <g filter="url(#b)">
      <rect
        x={15.166}
        y={28.709}
        width={21.667}
        height={7.583}
        rx={3.792}
        fill="#49454F"
      />
    </g>
    <g filter="url(#c)">
      <mask id="f" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.813 30.334c.268 0 .485.217.485.485v.782l.726-.42a.486.486 0 0 1 .484.841l-.726.42.727.42a.486.486 0 0 1-.485.84l-.726-.42v.9a.485.485 0 1 1-.97 0v-.9l-.726.42a.486.486 0 0 1-.484-.841l.725-.42-.726-.42a.486.486 0 0 1 .485-.84l.727.42v-.782c0-.268.217-.485.484-.485Zm6.188 0c.267 0 .484.217.484.485v.782l.727-.42a.486.486 0 0 1 .484.841l-.726.42.726.42a.486.486 0 0 1-.485.84l-.726-.42v.9a.485.485 0 1 1-.97 0v-.9l-.726.42a.486.486 0 0 1-.484-.841l.726-.42-.726-.42a.486.486 0 0 1 .484-.84l.727.42v-.782c0-.268.217-.485.485-.485Zm6.67.485a.485.485 0 1 0-.969 0v.782l-.727-.42a.486.486 0 0 0-.484.841l.726.42-.726.42a.486.486 0 0 0 .484.84l.727-.42v.9a.485.485 0 1 0 .97 0v-.9l.726.42a.486.486 0 0 0 .484-.841l-.726-.42.726-.42a.486.486 0 0 0-.484-.84l-.727.42v-.782Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.813 30.334c.268 0 .485.217.485.485v.782l.726-.42a.486.486 0 0 1 .484.841l-.726.42.727.42a.486.486 0 0 1-.485.84l-.726-.42v.9a.485.485 0 1 1-.97 0v-.9l-.726.42a.486.486 0 0 1-.484-.841l.725-.42-.726-.42a.486.486 0 0 1 .485-.84l.727.42v-.782c0-.268.217-.485.484-.485Zm6.188 0c.267 0 .484.217.484.485v.782l.727-.42a.486.486 0 0 1 .484.841l-.726.42.726.42a.486.486 0 0 1-.485.84l-.726-.42v.9a.485.485 0 1 1-.97 0v-.9l-.726.42a.486.486 0 0 1-.484-.841l.726-.42-.726-.42a.486.486 0 0 1 .484-.84l.727.42v-.782c0-.268.217-.485.485-.485Zm6.67.485a.485.485 0 1 0-.969 0v.782l-.727-.42a.486.486 0 0 0-.484.841l.726.42-.726.42a.486.486 0 0 0 .484.84l.727-.42v.9a.485.485 0 1 0 .97 0v-.9l.726.42a.486.486 0 0 0 .484-.841l-.726-.42.726-.42a.486.486 0 0 0-.484-.84l-.727.42v-.782Z"
        fill="url(#d)"
        shapeRendering="crispEdges"
      />
      <path
        d="M20.298 31.6h-1v1.734l1.5-.868-.5-.866Zm.726-.42-.5-.865.5.865Zm.662.178-.867.5.867-.5Zm-.177.664-.501-.866.5.866Zm-.727.42-.5-.866-1.497.865 1.497.866.5-.866Zm.727.42.5-.866-.5.865Zm.177.663-.867-.5.867.5Zm-.662.178-.5.865.5-.865Zm-.726-.42.5-.866-1.5-.868v1.734h1Zm-.97 0h1v-1.734l-1.5.867.5.866Zm-.726.42.5.865-.5-.865Zm-.662-.178.866-.5-.866.5Zm.177-.664.5.866-.5-.866Zm.726-.42.5.866 1.498-.866-1.497-.865-.5.865Zm-.726-.42-.5.866.5-.865Zm-.177-.663.866.5-.866-.5Zm.662-.178.5-.865-.5.865Zm.727.42-.5.867 1.5.867v-1.733h-1Zm7.156 0h-1v1.734l1.5-.868-.5-.866Zm.727-.42.5.866-.5-.866Zm.484.842.5.865-.5-.865Zm-.726.42-.5-.866-1.498.865 1.497.866.5-.866Zm.726.42.5-.866-.5.865Zm-.485.84.501-.865-.5.866Zm-.726-.42.5-.865-1.5-.868v1.734h1Zm-.97 0h1V31.55l-1.5.867.5.866Zm-.726.42-.5-.865.5.866Zm-.662-.177.867-.5-.867.5Zm.178-.664-.501-.865.5.865Zm.726-.42.5.866 1.497-.866-1.497-.865-.5.865Zm-.726-.42.5-.865-.5.866Zm-.178-.663.867.5-.867-.5Zm.662-.178-.5.866.5-.866Zm.727.42-.5.867 1.5.867v-1.733h-1Zm6.186 0-.5.867 1.5.867v-1.733h-1Zm-.727-.42-.5.866.5-.866Zm-.662.178-.867-.498.867.498Zm.178.664-.5.865.5-.865Zm.726.42.5.865 1.497-.866-1.497-.865-.5.865Zm-.726.42-.5-.866.5.865Zm-.178.663-.867.499.867-.5Zm.662.178-.5-.866.5.866Zm.727-.42h1v-1.734l-1.5.867.5.866Zm.97 0 .5-.866-1.5-.868v1.734h1Zm.726.42.5-.866-.5.866Zm.484-.842.5-.865-.5.865Zm-.726-.42-.5-.865-1.498.865 1.497.866.5-.866Zm.726-.42.5.866-.5-.865Zm-.484-.84.5.865-.5-.866Zm-.727.42h-1v1.733l1.5-.868-.5-.866Zm-11.373-.782c0-.818-.663-1.485-1.485-1.485v2a.515.515 0 0 1-.515-.515h2Zm0 .782v-.782h-2v.782h2Zm-.774-1.286-.727.42 1.001 1.731.727-.42-1.001-1.731Zm2.029.544a1.484 1.484 0 0 0-2.03-.544l1.002 1.731a.516.516 0 0 1-.706-.189l1.734-.997Zm-.544 2.028c.71-.41.952-1.318.544-2.027l-1.734.997a.514.514 0 0 1 .189-.701l1.001 1.731Zm-.726.42.726-.42-1.001-1.731-.726.42 1.001 1.731Zm.726-1.311-.726-.42-1.001 1.731.726.42 1.001-1.731Zm.544 2.028a1.486 1.486 0 0 0-.544-2.028l-1.001 1.731a.514.514 0 0 1-.189-.701l1.734.998Zm-2.03.544c.712.412 1.62.166 2.03-.544l-1.734-.998a.516.516 0 0 1 .706-.189l-1.001 1.731Zm-.726-.42.727.42 1-1.731-.726-.42-1 1.731Zm1.5.033v-.898h-2v.898h2Zm-1.484 1.486c.822 0 1.485-.668 1.485-1.486h-2c0-.282.228-.514.515-.514v2ZM18.33 34.18c0 .819.662 1.486 1.484 1.486v-2c.287 0 .516.232.516.514h-2Zm0-.899v.9h2v-.9h-2Zm.773 1.286.727-.42-1-1.732-.728.421 1.001 1.731Zm-2.029-.544c.41.71 1.317.956 2.03.544L18.1 32.837a.516.516 0 0 1 .705.189l-1.733.998Zm.544-2.028a1.486 1.486 0 0 0-.544 2.028l1.733-.998a.514.514 0 0 1-.188.701l-1.001-1.731Zm.726-.42-.726.42 1 1.731.727-.42-1.001-1.731Zm-.726 1.311.726.42 1-1.731-.725-.42-1.001 1.731Zm-.544-2.027a1.486 1.486 0 0 0 .544 2.027l1-1.731c.247.143.33.457.19.701l-1.734-.997Zm2.03-.545a1.484 1.484 0 0 0-2.03.544l1.733.998a.516.516 0 0 1-.705.19l1.001-1.732Zm.726.42-.727-.42-1.001 1.731.727.42 1.001-1.73Zm-1.5.084v.782h2v-.782h-2Zm1.484-1.485c-.822 0-1.484.667-1.484 1.485h2a.515.515 0 0 1-.516.515v-2Zm7.672 1.485c0-.818-.662-1.485-1.485-1.485v2a.515.515 0 0 1-.515-.515h2Zm0 .782v-.782h-2v.782h2Zm-.774-1.286-.727.42 1.002 1.731.726-.42-1.001-1.731Zm2.029.544a1.484 1.484 0 0 0-2.03-.544l1.002 1.731a.516.516 0 0 1-.705-.189l1.733-.997Zm-.544 2.028c.71-.41.952-1.318.544-2.027l-1.733.997a.514.514 0 0 1 .188-.701l1.001 1.731Zm-.726.42.726-.42-1-1.731-.727.42 1.001 1.731Zm.726-1.311-.726-.42-1 1.731.725.42 1.001-1.731Zm.544 2.028a1.486 1.486 0 0 0-.544-2.028l-1 1.731a.514.514 0 0 1-.19-.701l1.734.998Zm-2.03.544c.712.412 1.62.166 2.03-.544l-1.733-.998a.516.516 0 0 1 .705-.189l-1.001 1.731Zm-.726-.42.727.42 1.001-1.731-.726-.42-1.002 1.731Zm1.501.033v-.898h-2v.898h2ZM26 35.667c.823 0 1.485-.668 1.485-1.486h-2c0-.282.229-.514.515-.514v2Zm-1.484-1.486c0 .819.662 1.486 1.485 1.486v-2c.286 0 .515.232.515.514h-2Zm0-.899v.9h2v-.9h-2Zm.773 1.286.727-.42-1-1.732-.728.421 1.001 1.731Zm-2.029-.544c.41.71 1.318.956 2.03.544l-1.002-1.731a.516.516 0 0 1 .706.189l-1.734.998Zm.544-2.028a1.486 1.486 0 0 0-.544 2.028l1.734-.998a.514.514 0 0 1-.189.701l-1.001-1.731Zm.726-.42-.726.42 1.001 1.731.726-.42-1.001-1.731Zm-.726 1.311.726.42 1.001-1.731-.726-.42-1.001 1.731Zm-.544-2.027a1.486 1.486 0 0 0 .544 2.027l1.001-1.731c.247.143.33.457.189.701l-1.734-.997Zm2.03-.545a1.484 1.484 0 0 0-2.03.544l1.734.998a.516.516 0 0 1-.706.19l1.001-1.732Zm.727.42-.728-.42-1 1.731.726.42 1.002-1.73Zm-1.501.084v.782h2v-.782h-2ZM26 29.334c-.823 0-1.485.667-1.485 1.485h2a.515.515 0 0 1-.515.515v-2Zm6.186 2a.515.515 0 0 1-.516-.515h2c0-.818-.662-1.485-1.484-1.485v2Zm.515-.515a.515.515 0 0 1-.515.515v-2c-.822 0-1.485.667-1.485 1.485h2Zm0 .782v-.782h-2v.782h2Zm-2.228.445.728.42 1-1.73-.726-.421-1.002 1.731Zm.706-.189a.516.516 0 0 1-.706.19l1.002-1.732a1.484 1.484 0 0 0-2.03.544l1.734.998Zm-.189-.701c.247.143.33.457.189.701l-1.734-.997a1.486 1.486 0 0 0 .544 2.027l1.001-1.731Zm.726.42-.726-.42-1 1.731.725.42 1.001-1.731Zm-.726 2.151.726-.42-1-1.731-.727.42 1.001 1.731Zm.189-.701a.514.514 0 0 1-.189.701l-1-1.731a1.486 1.486 0 0 0-.545 2.028l1.734-.998Zm-.706-.189a.516.516 0 0 1 .706.189l-1.734.998c.41.71 1.318.956 2.03.544l-1.002-1.731Zm.728-.42-.728.42 1.002 1.731.727-.42-1.001-1.732Zm1.5 1.764v-.899h-2v.9h2Zm-.515-.514c.287 0 .515.232.515.514h-2c0 .819.663 1.486 1.485 1.486v-2Zm-.516.514c0-.282.229-.514.516-.514v2c.822 0 1.484-.668 1.484-1.486h-2Zm0-.898v.898h2v-.898h-2Zm2.227-.446-.726-.42-1.001 1.731.726.42 1.001-1.731Zm-.705.189a.516.516 0 0 1 .705-.189l-1 1.731c.71.412 1.62.166 2.028-.544l-1.733-.998Zm.188.701a.514.514 0 0 1-.188-.701l1.733.998a1.486 1.486 0 0 0-.543-2.028l-1.002 1.731Zm-.726-.42.726.42 1.002-1.731-.727-.42-1 1.731Zm.726-2.151-.726.42 1.002 1.731.726-.42-1.002-1.731Zm-.188.701a.514.514 0 0 1 .188-.701l1.002 1.731c.71-.41.951-1.318.543-2.027l-1.733.997Zm.705.19a.516.516 0 0 1-.705-.19l1.733-.997a1.484 1.484 0 0 0-2.029-.545l1.001 1.731Zm-.726.42.726-.42-1-1.732-.727.42 1 1.731Zm-1.5-1.648v.782h2v-.782h-2Z"
        fill="url(#e)"
        fillOpacity={0.1}
        mask="url(#f)"
      />
    </g>
    <path
      d="M39.541 46.583a8.667 8.667 0 1 0 0-17.333 8.667 8.667 0 0 0 0 17.333Z"
      fill="#49454F"
    />
    <path
      d="M47.208 37.917a7.667 7.667 0 1 1-15.333 0 7.667 7.667 0 0 1 15.333 0Z"
      stroke="url(#g)"
      strokeOpacity={0.1}
      strokeWidth={2}
    />
    <g filter="url(#h)" shapeRendering="crispEdges">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.166 32.955a.953.953 0 0 0-.936-.802h-1.452a.954.954 0 0 0-.867.9l-.032.411-.011.092-.022.092a.9.9 0 0 1-.352.504l-.076.049-.016.01-.081.044a.928.928 0 0 1-.786-.016l-.379-.195-.081-.038a.964.964 0 0 0-1.165.4l-.693 1.209-.038.08c-.19.429-.06.922.32 1.187l.352.238.075.06a.949.949 0 0 1 .336.72.938.938 0 0 1-.406.775l-.352.238-.07.055a.944.944 0 0 0-.206 1.23l.677 1.19.043.077c.26.384.764.52 1.197.308l.396-.195.081-.032.087-.027a.975.975 0 0 1 .617.054l.038.016.049.027.076.049a.93.93 0 0 1 .39.688l.032.428.011.081c.076.46.471.802.937.802h1.452a.954.954 0 0 0 .866-.9l.033-.411.01-.092.022-.092a.9.9 0 0 1 .352-.504l.076-.054.017-.011.08-.043a.927.927 0 0 1 .786.016l.39.19.076.032a.968.968 0 0 0 1.16-.406l.692-1.208.038-.076a.973.973 0 0 0-.308-1.18l-.363-.25-.076-.06a.949.949 0 0 1-.336-.72c0-.314.157-.607.406-.775l.352-.238.07-.054a.944.944 0 0 0 .207-1.23l-.677-1.18-.044-.076a.948.948 0 0 0-1.197-.31l-.395.196-.081.032-.087.028a.975.975 0 0 1-.618-.055l-.038-.016-.048-.027-.076-.049a.93.93 0 0 1-.39-.688l-.033-.428-.01-.08v.01Zm-1.619 2.46a2.497 2.497 0 0 1 2.486 2.502 2.497 2.497 0 0 1-2.486 2.502 2.497 2.497 0 0 1-2.486-2.502 2.497 2.497 0 0 1 2.486-2.503Zm-1.094 2.502c0-.612.493-1.11 1.094-1.11.601 0 1.094.498 1.094 1.11 0 .612-.493 1.11-1.094 1.11a1.105 1.105 0 0 1-1.094-1.11Z"
        fill="url(#i)"
      />
      <path
        d="M40.673 33.036h.001l.006.041.031.414v.001c.034.425.251.808.598 1.056l.01.007.01.007.076.049.014.008.014.008.049.027.022.013.024.01.036.015s0 0 0 0c.301.13.629.156.934.081l.016-.004.015-.004.087-.027.018-.006.018-.007.081-.033.019-.007.017-.009.392-.193a.45.45 0 0 1 .556.126l.032.057h0l.678 1.181.005.008.005.009a.444.444 0 0 1-.094.573l-.051.04-.34.229s0 0 0 0a1.437 1.437 0 0 0-.626 1.189c0 .425.191.83.513 1.102l.007.006.007.006.076.06.012.01.014.008.353.242a.473.473 0 0 1 .15.56l-.027.055-.682 1.188a.47.47 0 0 1-.543.199l-.055-.023-.378-.184s0 0 0 0a1.428 1.428 0 0 0-1.208-.024l-.017.007-.016.008-.08.044-.022.011-.02.014-.017.01-.007.005-.006.005-.076.054-.001.001a1.4 1.4 0 0 0-.544.782h0l-.003.013-.022.092-.007.028-.003.028-.01.093-.002.009v.01l-.033.411v.008l-.001.009a.454.454 0 0 1-.395.422H38.86a.453.453 0 0 1-.443-.377l-.007-.058-.032-.414v-.001a1.43 1.43 0 0 0-.598-1.056l-.01-.007-.01-.007-.076-.048-.013-.009-.014-.008-.05-.027-.022-.012-.023-.01-.036-.016h-.001c-.3-.13-.628-.155-.934-.081l-.015.004-.016.005-.086.027-.019.005-.018.008-.081.032-.018.007-.017.009-.394.194s0 0 0 0a.438.438 0 0 1-.555-.127l-.031-.055-.001-.001-.676-1.19-.006-.01-.005-.01a.444.444 0 0 1 .094-.573l.05-.04.34-.228s0 0 0 0a1.438 1.438 0 0 0 .113-2.292l-.006-.006-.008-.005-.075-.06-.014-.01-.015-.01-.348-.236a.462.462 0 0 1-.148-.569l.026-.057.678-1.181a.465.465 0 0 1 .541-.197l.056.026.37.19h0l.01.005c.39.19.831.191 1.208.024l.016-.007.016-.009.081-.043.022-.012.02-.013.013-.009.072-.046.011-.007.01-.008a1.4 1.4 0 0 0 .545-.782h0l.003-.013.022-.092.006-.028.003-.028.011-.092.001-.01.001-.01.033-.411v-.017a.454.454 0 0 1 .395-.422h1.425c.216 0 .406.16.443.383Zm1.86 4.88c0-1.647-1.33-3.002-2.986-3.002-1.656 0-2.986 1.355-2.986 3.003 0 1.647 1.33 3.002 2.986 3.002 1.656 0 2.986-1.355 2.986-3.002Zm-3.58 0c0-.342.275-.61.594-.61.319 0 .594.268.594.61 0 .343-.275.611-.594.611a.605.605 0 0 1-.594-.61Z"
        stroke="url(#j)"
        strokeOpacity={0.1}
        strokeLinecap="round"
      />
    </g>
    <defs>
      <linearGradient
        id="a"
        x1={26}
        y1={21.125}
        x2={26}
        y2={43.875}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="d"
        x1={26}
        y1={30.334}
        x2={26}
        y2={34.667}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EAE3BF" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="e"
        x1={26}
        y1={30.334}
        x2={26}
        y2={34.667}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="g"
        x1={39.541}
        y1={29.25}
        x2={39.541}
        y2={46.583}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="i"
        x1={39.544}
        y1={32.153}
        x2={39.544}
        y2={43.664}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.9} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="j"
        x1={39.544}
        y1={32.153}
        x2={39.544}
        y2={43.664}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <filter
        id="b"
        x={15.166}
        y={28.709}
        width={21.667}
        height={8.584}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_675_7431"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_675_7431"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend in2="shape" result="effect2_innerShadow_675_7431" />
      </filter>
      <filter
        id="c"
        x={17.875}
        y={30.334}
        width={16.25}
        height={5.333}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_675_7431"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_675_7431"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0" />
        <feBlend in2="shape" result="effect2_innerShadow_675_7431" />
      </filter>
      <filter
        id="h"
        x={34.085}
        y={32.153}
        width={10.918}
        height={12.51}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_675_7431"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_675_7431"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" />
        <feBlend in2="shape" result="effect2_innerShadow_675_7431" />
      </filter>
    </defs>
  </svg>
)

export default SvgPassword;
